import React, { Component } from 'react';
import './Footer.css';

class Footer extends Component {
  render() {
    return (
      <footer>
        <p>
          Need help or have feedback? Email us at <a href="mailto:info@dietid.com">info@dietid.com</a> or call us.
          <br />© 2021 Diet ID. All Rights Reserved.
        </p>
      </footer>
    );
  }
}
export class AltFooter extends Component {
  render() {
    return (
      <footer>
        <p>© 2021 Diet ID. All Rights Reserved.</p>
      </footer>
    );
  }
}

export default Footer;
